import { RootState } from '../store';

/**
 * Selectors for UI state
 */

export const selectIsGlobalLoading = (state: RootState) => state.ui.isLoading;
export const selectLoadingMessage = (state: RootState) => state.ui.loadingMessage;
